module.exports = __webpack_public_path__ + "img/android-icon-192x192.82e54f7.png";